<template>
  <div :class="{'rt-switch__wrapper': true, 'price-switch': priceMode}">
    <div class="rt-switch__label-wrapper" :class="{'has-tooltip': tooltipVisible}">
        <div class="rt-switch__label" v-if="label">{{ label }}</div>
        <div class="tooltip-wrapper"
            v-tooltip="{
                content: tooltip,
                trigger: 'hover click'
            }"
            v-if="tooltipVisible"
        >
            <rt-picture class="icon-help" src="/assets/app/class/icon-help.svg"></rt-picture>
        </div>
        <rt-picture class="icon-premium" src="/assets/app/navigation/icon-diamond.svg" v-if="showPremium"></rt-picture>
    </div>
    <div :class="{'rt-switch__control-wrapper': true, 'active': value}" ref="switchControl" @click="onClickSwitchControl">
        <span :class="{ 'rt-switch__circle': true, 'active': value }" v-if="!priceMode"></span>
        <span class="rt-switch__control-label on" v-if="value || priceMode">{{ activeLabel }}</span>
        <span class="rt-switch__control-label off" v-if="!value || priceMode">{{ invactiveLavel }}</span>
    </div>
    <input ref="switch"
        type="checkbox"
        :name="name"
        :checked="value"
        hidden
        @input="handleInputCheck">
  </div>
</template>

<script>
    import Vue from 'vue';
    import VTooltip from 'v-tooltip';
    import _ from 'lodash';
    import RtPicture from './Picture.vue';

    Vue.use(VTooltip);

    export default {
        components: {
            RtPicture
        },
        computed: {
            activeLabel() {
                if (this.priceMode) {
                    return 'MONTHLY';
                } else {
                    return 'ON';
                }
            },
            invactiveLavel() {
                if (this.priceMode) {
                    return 'ANNUALLY';
                } else {
                    return 'OFF';
                }
            },
            tooltipVisible() {
              return this.tooltip || this.tooltip === ''
            }
        },
        methods: {
          onClickSwitchControl() {
            this.$nextTick(this.$refs.switch.click());
          },
          handleInputCheck() {
            this.$emit('input', !this.value);
          }
        },
        props: ['name', 'value', 'label', 'priceMode', 'tooltip', 'showPremium']
    }
</script>

<style scoped lang="scss">

    @import './variables';

    .rt-switch__wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        &.price-switch {
            justify-content: center;

            .rt-switch__control-wrapper {
                width: 248px;
                min-width: 60px;
                height: 36px;
                background: #DFECFE;
                padding: 0;
                border-radius: 32px;

                .rt-switch__control-label {
                    flex: 1;
                    height: 36px;
                    line-height: 36px;
                    border-radius: 32px;
                    text-align: center;

                    &.on {
                        background: $light-blue2;
                        color: white;
                    }
                    &.off {
                        color: $light-blue2;
                    }
                }
                &.active {
                    .rt-switch__control-label {
                        &.on {
                            background: transparent;
                            color: $light-blue2;
                        }
                        &.off {
                            background: $light-blue2;
                            color: white;
                        }
                    }
                }
            }
        }
    }
    .rt-switch__label-wrapper {
      display: flex;
      align-items: center;
      position: relative;
      .tooltip-wrapper {
        display: flex;
        margin-right: 8px;
      }
      &.has-tooltip {
        .rt-switch__label {
          width: auto;
          max-width: 16rem;
          margin-right: 8px;
        }
      }
    }
    .rt-switch__label {
        width: 19.69rem;
        font-size: 0.87rem;
        color: $grey-100;
    }

    .rt-switch__control-wrapper {
        display: flex;
        align-items: center;
        width: 60px;
        min-width: 60px;
        height: 1.62rem;
        background: rgba(238, 245, 255, 0.7);
        border-radius: 15px;
        padding-left: 14px;
        padding-right: 11px;
        position: relative;
        cursor: pointer;
    }

    .rt-switch__circle {
        position: absolute;
        left: 5px;
        top: 5px;
        width: 16px;
        height: 16px;
        background: rgba(100, 100, 100, 0.5);
        border-radius: 50%;

        &.active {
            left: auto;
            right: 5px;
            background: $primary-dark-blue;
        }
    }

    .rt-switch__control-label {
        font-size: 0.75rem;
        color: $grey-100;
        user-select: none;

        &.off {
            width: 100%;
            text-align: right;
        }
    }

</style>
